import { COUNTRY_COOKIE_NAME, SEX_ORIENTATION_COOKIE_NAME } from '@/config/app';
import { getCookie } from './cookie';
import { SexualOrientation } from '@/types';

export const redirect = (path: string) => {
    document.location = path;
};

export const scrollIntoView = (element: HTMLElement) => {
    // HTMLElement.scrollIntoView is undefined in 'node' environment (Eg. when running unit tests)
    if (!element || typeof element.scrollIntoView !== 'function') {
        return;
    }

    element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
    });
};

export const getFocusedElement = (): HTMLElement | null => {
    if (typeof document === 'undefined') {
        return null;
    }

    return document.activeElement as HTMLElement | null;
};

export const getSexualOrientation = (): SexualOrientation => {
    const sexCookieValue = getCookie(SEX_ORIENTATION_COOKIE_NAME);

    if (!sexCookieValue) {
        return 'straight';
    }

    return sexCookieValue as SexualOrientation;
};

export const getCountry = (): string => {
    const countryCookieValue = getCookie(COUNTRY_COOKIE_NAME);

    if (!countryCookieValue) {
        return 'US';
    }

    return countryCookieValue;
};
